// Copyright (c) Ensho Health, 2021 to present

import axios from 'axios';

// API is an env config
const config = {
  // eslint-disable-next-line no-undef
  baseURL: process.env.REACT_APP_API
};

const client = axios.create(config);

export default client;